export default __webpack_public_path__ + "static/media/check-out-with-bg.fe70f784.png";